/**
 * QuickBooks Online — Disconnect confirmation page.
 *
 * This exact route (/qbo/disconnected) is registered with Intuit as this
 * app's Disconnect URL in the submitted app configuration — it must exist
 * at this path. Intuit redirects the browser here after a user revokes
 * ClickPay's access from their Intuit account (or after the app's own
 * disconnect flow completes).
 *
 * Rendered OUTSIDE the ClickPay auth wall / app shell (see App.tsx) — the
 * QBO session that lands here is not necessarily a signed-in ClickPay
 * session.
 *
 * The "back to Integrations" link goes straight to Settings › Integrations
 * (/ops?tab=integrations, PR 7), where QuickBooks is connected again.
 */
import { CheckCircle2 } from 'lucide-react'
import { settingsHref } from './settings/routing'

export default function QboDisconnected() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto w-12 h-12 rounded-xl bg-gray-200 text-gray-600 flex items-center justify-center mb-3 shadow-sm">
          <CheckCircle2 size={22} aria-hidden />
        </div>
        <h1 className="text-xl font-semibold text-gray-900">ClickPay</h1>
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 mt-4">
          <p className="text-sm text-gray-900">
            QuickBooks has been disconnected.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            ClickPay no longer has access to your QuickBooks Online data.
            You can reconnect at any time from Integrations settings.
          </p>
          <a
            href={settingsHref('integrations')}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1 mt-4"
          >
            Back to Integrations
          </a>
        </div>
      </div>
    </div>
  )
}
